export default {
  rural: 3,
  urban: 2,
  ruralAfterThurs: 'Thursday', // earliest deleivery after 12pm Thurs 
  urbanAfterThurs: 'Wednesday' // earliest deleivery after 12pm Thurs
}